import { createConsumer } from '@rails/actioncable';

const CHANNEL_NAME = 'Integrations::OpenAI::Chatkit::RequestLiveAgentChannel';

let consumer = null;
let liveAgentSubscription = null;

export const subscribeLiveAgentChannel = (personId) => {
  if (liveAgentSubscription) return;
  if (!personId) return;

  if (!consumer) {
    consumer = createConsumer();
  }

  liveAgentSubscription = consumer.subscriptions.create(
    { channel: CHANNEL_NAME, person_id: personId },
    {
      received(data) {
        document.dispatchEvent(new CustomEvent('chatkit.live-agent-request', { detail: data }));
      }
    }
  );
};

export const unsubscribeLiveAgentChannel = () => {
  if (liveAgentSubscription) {
    liveAgentSubscription.unsubscribe();
    liveAgentSubscription = null;
  }
};
